// Arabic-Indic (٠-٩) and Extended Arabic-Indic/Persian (۰-۹) digits, in order.
const NON_ENGLISH_DIGITS = ['٠١٢٣٤٥٦٧٨٩', '۰۱۲۳۴۵۶۷۸۹'];
const ARABIC_DIGIT_PATTERN = /[٠-٩۰-۹]/g;

export const toEnglishDigits = (value: string): string =>
  value.replace(ARABIC_DIGIT_PATTERN, (digit) => {
    for (const digitSet of NON_ENGLISH_DIGITS) {
      const index = digitSet.indexOf(digit);
      if (index !== -1) return String(index);
    }
    return digit;
  });

// The backend is expected to send numbers as plain English-digit
// strings/numbers, but if any field ever comes back with Arabic-Indic
// digits, normalize it here once so every screen in the app is protected
// without each component needing its own fix.
export const normalizeArabicNumeralsDeep = (data: any): any => {
  if (typeof data === 'string') return toEnglishDigits(data);
  if (Array.isArray(data)) return data.map(normalizeArabicNumeralsDeep);
  if (data && typeof data === 'object') {
    const result: any = {};
    for (const key of Object.keys(data)) {
      result[key] = normalizeArabicNumeralsDeep(data[key]);
    }
    return result;
  }
  return data;
};
